import { PropsWithChildren } from 'react'
import { useAISuggestionRequest } from 'hooks/queries/aiSuggestionRequests/useAISuggestionRequest'
import { ImageGenerateRequestGeneratedContent, SuggestionRequestStatus } from 'types'
import { Text } from 'blaze-ui/Text/Text'
import { Toast } from 'common/ToastMessage'
import { Spinner } from 'common/Spinner/Spinner'
import Styles from './Preview.module.scss'
import { PreviewContainerProps, PreviewProps } from './Types'
import { Field } from './Field'
const PreviewPlaceholder = ({ children }: PropsWithChildren) => (
  <div className={Styles.previewPlaceholder}>{children}</div>
)

const GenerationFailed = () => (
  <PreviewPlaceholder>
    <Text>Failed to generate image</Text>
  </PreviewPlaceholder>
)

const GeneratingImage = () => (
  <PreviewPlaceholder>
    <div className={Styles.generatingToast}>
      <Toast.Root variant="info">
        <Toast.Icon>
          <Spinner />
        </Toast.Icon>
        <Toast.Description>Generating image...</Toast.Description>
      </Toast.Root>
    </div>
  </PreviewPlaceholder>
)

const Preview = ({ requestId }: PreviewProps) => {
  const { data } = useAISuggestionRequest({ id: requestId })

  if (data?.request.status === SuggestionRequestStatus.Failed) {
    return <GenerationFailed />
  }

  const generatedContent = data?.request.generated_content

  if (!generatedContent) {
    return <GeneratingImage />
  }

  const generatedImages: ImageGenerateRequestGeneratedContent = JSON.parse(generatedContent)
  const img = generatedImages[0]

  return (
    <div className={Styles.preview}>
      <img src={img.url} alt={img.revisedPrompt} className={Styles.image} />
    </div>
  )
}

const PreviewContainer = ({ requestId }: PreviewContainerProps) => {
  if (!requestId) {
    return (
      <Field label="Generated Image">
        <PreviewPlaceholder>
          <Text>The image will appear here once generated</Text>
        </PreviewPlaceholder>
      </Field>
    )
  }

  return <Preview requestId={requestId} />
}

export { PreviewContainer as Preview }
